import { StorageValue } from './storage-value';
import { CacheStorageAbstract } from './cache-storage-abstract';

export class CacheMemoryStorage extends CacheStorageAbstract {
    private data: { [key: string]: StorageValue<unknown> } = {};

    public getItem<T>(key: string): StorageValue<T> {
        return this.data[key] ? this.data[key] as StorageValue<T> : null;
    }

    public setItem<T>(key: string, value: StorageValue<T>): boolean {
        this.data[key] = value;
        return true;
    }

    public removeItem(key: string): void {
        delete this.data[key];
    }

    public clear(): void {
        this.data = {};
    }
}
